module.exports = "/images/am.svg?75cbcbfc3e02eec10aebedd1da4821e8";